module.exports = __webpack_public_path__ + "static/media/sync-problem.01f78fdc.svg";